// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__gtXc2","active":"modal_active__x2Hf+","close":"modal_close__WlIUH","wrapper":"modal_wrapper__VSipt"};